var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M455.069 356.93C453.21 355.069 450.63 354 448 354s-5.21 1.069-7.07 2.93A10.058 10.058 0 0 0 438 364c0 2.63 1.069 5.21 2.93 7.069 1.86 1.86 4.44 2.931 7.07 2.931s5.21-1.07 7.069-2.931C456.93 369.21 458 366.63 458 364s-1.07-5.21-2.931-7.07z",
    fill: "#3243be",
    opacity: 1,
    "data-original": "#000000",
    className: "hovered-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 492h-44v-93c0-5.522-4.478-10-10-10s-10 4.478-10 10v93H122v-94c0-5.522-4.478-10-10-10s-10 4.478-10 10v94H74V229.002L256 86.915l182 142.087V324c0 5.522 4.478 10 10 10s10-4.478 10-10v-79.384l1.748 1.365a9.97 9.97 0 0 0 6.15 2.118 9.985 9.985 0 0 0 7.074-2.929l36.069-36.07a10 10 0 0 0-.918-14.954L448 147.208V47c0-5.523-4.478-10-10-10h-57.958c-5.522 0-10 4.477-10 10v39.346L262.153 2.118a10 10 0 0 0-12.307 0L3.876 194.146a10 10 0 0 0-.918 14.954l36.069 36.07a10.002 10.002 0 0 0 13.225.811L54 244.616V492H10c-5.522 0-10 4.478-10 10s4.478 10 10 10h492c5.522 0 10-4.478 10-10s-4.478-10-10-10zM390.042 57H428v74.594l-37.958-29.634V57zM46.916 224.774l-21.82-21.821L256 22.686l230.904 180.267-21.82 21.821L262.153 66.346A9.98 9.98 0 0 0 256 64.228a9.977 9.977 0 0 0-6.153 2.118L46.916 224.774z",
    fill: "#3243be",
    opacity: 1,
    "data-original": "#000000",
    className: "hovered-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 218H160c-5.522 0-10 4.477-10 10v192c0 5.522 4.478 10 10 10h192c5.522 0 10-4.478 10-10V228c0-5.523-4.478-10-10-10zM246 410h-76v-76h76v76zm0-96h-76v-76h76v76zm96 96h-76v-76h76v76zm0-96h-76v-76h76v76zM112 348.506c-5.522 0-10 4.477-10 10v.161c0 5.522 4.478 10 10 10s10-4.478 10-10v-.161c0-5.522-4.478-10-10-10z",
    fill: "#3243be",
    opacity: 1,
    "data-original": "#000000",
    className: "hovered-path"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBanking);
export default __webpack_public_path__ + "static/media/home_banking.f2a881c2d720a856e24c1b03c611b23e.svg";
export { ForwardRef as ReactComponent };